module.exports = __webpack_public_path__ + "img/winner.82d9605a.svg";